module.exports = "../static/media/banner_short.9d048f02.png";